import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-grid-shape',
  imports: [],
  templateUrl: './grid-shape.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: ``
})
export class GridShapeComponent {

}
